import React, { useState } from 'react'
import MonthFilter from './_filter'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { DateTime } from 'luxon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useNavigate } from 'react-router-dom'
import YearFilter from './_filter';

function ListGas({data, year}) {
    const navigate = useNavigate()
    return (
        <div className="year_list" style={{marginTop: '40px'}}>
            <p className="year_list-title">Consulta la tabella completa</p>
            <p className="year_list-secondary">
                Di seguito è riportata la tabella per i tuoi consumi e spese suddivisa mensilmente.
            </p>
            {/* <div className="year_list-filter">
                <div className="year_list-filter_date">
                    <YearFilter yearPrevious={yearPrevious} data={data} goForward={() => goForward()} goBack={() => goBack()} year={year} lastYear={lastYear} />
                </div>
                <div className="year_list-filter_letture">
                    <div className="year_list-filter_letture-container" onClick={() => navigate('/enrica/letture')}>
                        <p>Letture</p>
                        <ArrowForwardIosIcon />
                    </div>
                </div>
            </div> */}
            <div className="year_list-items">
                <div className="year_list-item-index">
                    <p className="year">Mese</p>
                    <p className="prezzo">Consumo</p>
                    <p className="euro">Euro</p>
                </div>
                {data && data
                .filter((d) => d.mese.includes(year))
                .slice(0, 8)
                .map((r) => (
                
                    <div className="year_list-item">
                        <p className="year">{DateTime.fromISO(r.mese).toFormat('MMMM')}</p>
                        <p className="prezzo">{parseFloat(r.consumo_mc).toFixed(0).replace(/\./g, ",")} Smc</p>
                        <p className="euro">{parseFloat(r.costo).toFixed(2).replace(/\./g, ",")} €</p>
                    </div>
                    
                ))}
            </div>
            {/* {data && data.filter((d) => d.id !== null).length >= maxItems ? (
                <div className="year_list-more" onClick={() => setMaxItems(maxItems + 6)}>
                    <p>Mostra di più</p>
                    <KeyboardArrowDownIcon />
                </div>
            ) : (
                <div className="year_list-more">
                    <p>Nient'altro da visualizzare.</p>
                </div>
            )} */}
        </div>
    )
}

export default ListGas